(() => {
  'use strict';
  if (window.NAAYLPOColorDotScope?.initialized) return;
  // Passive field classification only: never alter inputs, selection, price or media.
  const GROUP = '.cl-po--swatch-container';
  const LABELS = '.cl-po--label, .cl-po--label-text, [class*="cl-po--label-title"]';
  const COLOR = /^(?:顏色|牽繩顏色|胸背帶顏色|扣頭顏色|主色|副色|色票|色彩)(?:[：:\s]|$)/u;
  const EXCLUDE = /^(?:配色方式|扣頭|尺寸|長度|升級版本)/u;
  const MARK = 'data-naay-lpo-color-dots';
  const TIPPY_THEME = 'naay-lpo-color';

  function configureColorTooltip(swatch) {
    // LPO's Tippy instance may initialize after the swatch DOM is inserted.
    const tippy = swatch._tippy;
    if (!tippy || typeof tippy.setProps !== 'function') return;
    const oldThemes = String(tippy.props?.theme || '').split(/\s+/).filter(Boolean);
    const hasTheme = oldThemes.includes(TIPPY_THEME);
    if (hasTheme && tippy.props?.placement === 'top') return;
    if (!hasTheme) oldThemes.push(TIPPY_THEME);
    // Preserve other Tippy settings/themes, including flip and triggers.
    tippy.setProps({ placement: 'top', theme: oldThemes.join(' ') });
  }

  function configureGroupTooltips(group) {
    // Only true LPO color swatches; never button swatches or "注意事項".
    group.querySelectorAll('.cl-po--swatch-color[data-tippy-content]').forEach(configureColorTooltip);
  }

  function configureFromEvent(event) {
    const target = event.target;
    if (!(target instanceof Element)) return;
    const swatch = target.closest('.cl-po--swatch-color[data-tippy-content]');
    if (!swatch) return;
    // Tippy is color-only by element identity, not by the field heading.
    // Multi-color mode ("開始配色") uses different option/label wrappers.
    const root = document.querySelector('body.template-product .m-main-product--info');
    if (!root || !root.contains(swatch)) return;
    configureColorTooltip(swatch);
  }

  function isColorField(group) {
    let parent = group.parentElement;
    for (let level = 0; parent && level < 7; level++, parent = parent.parentElement) {
      // Never match a broad wrapper containing multiple option fields.
      if (parent.querySelectorAll(GROUP).length !== 1) continue;
      const labels = parent.querySelectorAll(LABELS);
      for (const label of labels) {
        const value = (label.textContent || '').replace(/\s+/g, ' ').trim();
        if (!EXCLUDE.test(value) && COLOR.test(value)) return true;
      }
    }
    return false;
  }

  function refresh() {
    const root = document.querySelector('body.template-product .m-main-product--info');
    if (!root) return;
    root.querySelectorAll(GROUP).forEach((group) => {
      if (isColorField(group)) {
        group.setAttribute(MARK, 'true');
        configureGroupTooltips(group);
      } else {
        group.removeAttribute(MARK);
      }
    });
    // All actual color-dot Tippy instances get the same theme, including
    // dynamic single/multicolor option groups that do not match LABELS.
    // Never alter the original MARK / 48px sizing classification.
    root.querySelectorAll('.cl-po--swatch-color[data-tippy-content]')
      .forEach(configureColorTooltip);
  }

  let scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      refresh();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule, { once: true });
  } else {
    schedule();
  }
  // Tippy can be initialized after the DOM observer runs. Capture the first
  // interaction so the tooltip is styled before the normal hover appears.
  document.addEventListener('pointerover', configureFromEvent, true);
  document.addEventListener('focusin', configureFromEvent, true);
  document.addEventListener('touchstart', configureFromEvent, { capture: true, passive: true });
  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  window.NAAYLPOColorDotScope = { initialized: true, refresh: schedule };
})();